<div class="form-wrapper">
  <div class="form-content size size1of1">
    <div *ngIf="statusForCurrencyBase" class="form-content size size1of1">
      <div [formGroup]="form" class="form-block">
        <!-- Charge Model -->
        <div class="form-row row-flex-wrap">
          <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
            <mat-label>Charge Model</mat-label>
            <mat-select required (selectionChange)="onChangeChargeModel($event)" formControlName="chargeModel" disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
              <mat-option *ngFor="let priceModel of collectionOfPriceModel" [value]="priceModel.value" [disabled]="priceModel.value == _chargeModel.discountFixedAmount || priceModel.value == _chargeModel.discountPercentage || priceModel.value == _chargeModel.overagePricing || priceModel.value == _chargeModel.tieredWithOveragePricing" class="custom-mat-option">{{ priceModel.label }}</mat-option>
            </mat-select>
            <mat-error><error-messages [control]="form.get('chargeModel')"></error-messages></mat-error>
          </mat-form-field>
        </div>
        <!--Price Model. Flat Fee / Per Unit  -->
        <div *ngIf="!isTierPrice && (selectedChargeModel == _chargeModel.flatFeePricing || selectedChargeModel == _chargeModel.perUnitPricing)" class="form-row row-flex-wrap">
          <div fxFlex="50" class="input-with-select-cnt">
          <!-- Price -->
          <mat-form-field floatLabel="always" [class]="'input-with-select price-type custom-mat-form-field field-amount size size1of1 md-size1of2'"
            [ngClass]="{'md-size1of1': isSubscription}" *ngIf="_data.usageBased">
            <mat-select formControlName="priceType">
              <mat-option value="percent">%</mat-option>
              <mat-option value="currency">{{currencySymbol}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="always" class="input-with-select custom-mat-form-field field-amount size amountinput size1of1 md-size1of2">
            <mat-label>Amount (per unit)</mat-label>
            <!-- <span matPrefix>{{currencySymbol}}</span> -->
            <input matInput type="text" formControlName="price" required placeholder="0,000.00" maxlength="13"
              [cleave]="cleaveNumDecimalOptions">
            <span matSuffix>{{currencyIso3}}</span>
            <mat-error><error-messages [control]="form.get('price')"></error-messages></mat-error>
          </mat-form-field>
          </div>
          <!-- Qty -->
          <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1 md-size1of2">
            <mat-label>Quantity</mat-label>
            <input matInput type="text" formControlName="quantity" required placeholder="0" [cleave]="cleaveNumIntegerOptions" >
            <mat-error><error-messages [control]="form.get('quantity')"></error-messages></mat-error>
          </mat-form-field>
        </div>

        <!-- Price Model. Tiered / Volume  -->
        <div *ngIf="isTierPrice && (selectedChargeModel == _chargeModel.tieredPricing || selectedChargeModel == _chargeModel.volumePricing)" class="form-row row-charge-model-tiered">
          <div class="form-row-inner">
            <mat-list formArrayName="chargeTier" class="custom-mat-list list-grid-std list-rateplan-charge-tiers size size1of1">
              <mat-list-item [formGroupName]="$index" *ngFor="let item of collectionOfRatePlanChargeTiers; let $index=index; last as isLastChargeTier" class="custom-mat-list-item grid-row">
                <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field field-tiered-unit">
                  <mat-label>Starting Qty</mat-label>
                  <input matInput readonly formControlName="startingUnit" required>
                  <span matSuffix class="typo label fw300 semi-condensed">Units</span>
                  <mat-error><error-messages [control]="form.get('chargeTier')['controls'][$index].get('startingUnit')"></error-messages></mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field field-tiered-unit">
                  <mat-label>Ending Qty</mat-label>
                  <input matInput (focusout)="onFocusOutEndingQty($index, $event)" formControlName="endingUnit" placeholder="unlimited">
                  <span matSuffix class="typo label fw300 semi-condensed">Units</span>
                  <mat-error><error-messages [control]="form.get('chargeTier')['controls'][$index].get('endingUnit')"></error-messages></mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isTierPrice" appearance="outline" floatLabel="always" class="custom-mat-form-field field-tiered-unit">
                  <mat-label>Amount (per unit)</mat-label>
                  <span matPrefix>{{currencySymbol}}</span>
                  <input matInput formControlName="price" type="text" placeholder="0,000.00" required maxlength="13"  [cleave]="cleaveNumDecimalOptions">
                  <span matSuffix class="typo label fw300 semi-condensed">{{currencyIso3}}</span>
                  <mat-error><error-messages [control]="form.get('chargeTier')['controls'][$index].get('price')"></error-messages></mat-error>
                </mat-form-field>
                <button mat-icon-button (click)="onClickDeleteChargeTier($index)" [disabled]="$index == 0 || !isLastChargeTier" class="custom-mat-icon-button"><mat-icon svgIcon="ico-delete" class="custom-mat-icon ico-size ico-1xs"></mat-icon></button>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
        <!-- Tax -->
        <div class="form-row row-flex-wrap">
          <mat-form-field class="custom-mat-form-field size size1of1 md-size1of2">
            <mat-label>Tax Class</mat-label>
            <mat-select formControlName="taxClass" required class="custom-mat-select" (selectionChange)="onChangeTaxClass($event)">
              <mat-option *ngFor="let taxClass of collectionOfTaxClass" [value]="taxClass.value" class="custom-mat-option">{{taxClass.label}}</mat-option>
            </mat-select>
            <mat-error><error-messages [control]="form.get('taxClass')"></error-messages></mat-error>
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field size size1of1 md-size1of2">
            <mat-label *ngIf="form.get('taxClass').value != 'manualTax'">Tax Provider Tax Code</mat-label>
            <mat-label *ngIf="form.get('taxClass').value == 'manualTax'">Custom tax rate</mat-label>

            <input matInput formControlName="taxCode" required>
            <mat-error><error-messages [control]="form.get('taxCode')"></error-messages></mat-error>
          </mat-form-field>
        </div>
        <!-- product useSaleChannelData -->
        <div *ngIf="!isSubscription" class="form-row row-flex-wrap">
          <mat-checkbox formControlName="useSaleChannelData" color="primary" disableRipple="true" class="custom-mat-checkbox rounded checkbox-simple-line">
            <span class="flex typo semi-condensed fw400">Use Price & Qty from sale channel
              <mat-icon matSuffix matTooltipPosition="right" matTooltipClass="mat-tooltip" matTooltip="By checking this checkbox, Rebillia will ignore the price and quantity set in this page and will take the values from the sale channel integration" svgIcon="ico-help" class="custom-mat-icon ico-tooltip ico-size ico-2xs"></mat-icon>
            </span>
          </mat-checkbox>
        </div>
        <!-- subscription useSaleChannelData -->
        <div *ngIf="this.hasExternalRatePlanCharge && isEditOnCreatedSubscription && this.form.get('chargeModel').value !== _chargeModel.tieredPricing && this.form.get('chargeModel').value !== _chargeModel.volumePricing" class="form-row row-flex-wrap">
          <mat-checkbox formControlName="useSaleChannelData" (change)="isEditOnCreatedSubscription ? onChangeUseSaleChannelDataCheckbox() : null" color="primary" disableRipple="true" class="custom-mat-checkbox rounded checkbox-simple-line">
            <span class="flex typo semi-condensed fw400">Use Price & Qty from sale channel
              <mat-icon matSuffix matTooltipPosition="right" matTooltipClass="mat-tooltip" matTooltip="By checking this checkbox, Rebillia will ignore the price and quantity set in this page and will take the values from the sale channel integration" svgIcon="ico-help" class="custom-mat-icon ico-tooltip ico-size ico-2xs"></mat-icon>
            </span>
          </mat-checkbox>
        </div>
        <!-- allowChangeQuantity -->
        <div class="form-row row-flex-wrap">
          <mat-checkbox formControlName="allowChangeQuantity" color="primary" disableRipple="true" class="custom-mat-checkbox rounded checkbox-simple-line">
            <span class="typo semi-condensed fw400">Allow change Qty from sale channel</span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>

